var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframeAnalytics",attrs:{"title":"Iframe Analytics","src":`${_vm.analyticsUrl}dashboards/oms/global?tenant=${_vm.currentGroup.name}&hide_menu=true&disableSSO=1&dark=${_vm.$vuetify.theme.dark}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }